import {Component, forwardRef} from '@angular/core';
import {DictionariesService} from "../../../service";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {ViewDictionaryBase} from "../view-dictionary-base";
import {PageSwift} from "../../../../../../api/build";

@Component({
  selector: 'app-dict-qref-swift',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => QrefSwiftViewComponent),
    multi: true
  }],
  template: `
    <div class="mb-3 col-6 pl-0 pr-0">
      <label class="form-label">{{title}}
        <app-rq *ngIf="isFieldReq(formControl)" [isReadOnly]="isDisabled"></app-rq>
      </label>
      <app-custom-select *ngIf="dictionary | async as dict; else loading"
                         code="kokcm"
                         name="ncm"
                         [items]="dict"
                         [returnOnlyId]="true"
                         [formControl]="formControl"
                         [fieldsFromSearch]="['kokcm', 'ncm']"
                         [isInvalid]="submitted && formControl.errors">
        <ng-template let-item #labelTemplate>
          <b> {{ item.kokcm }} </b>
          {{ item.ncm }}
        </ng-template>
        <ng-template let-item let-search="search" #optionTemplate>
          <b> {{ item.kokcm }} </b>
          {{ item.ncm }}
        </ng-template>
      </app-custom-select>
      <ng-template #loading>
        ...загрузка
      </ng-template>
      <app-valid [logic]="formControl" [submitted]="submitted"></app-valid>
    </div>
  `
})
export class QrefSwiftViewComponent extends ViewDictionaryBase<PageSwift> {
  getDictionary = this.dictSrv.getQrefSwiftList();
  constructor(private dictSrv: DictionariesService) {
    super();
  }
}
